import Page404 from "views/pagesNoLayout/Page404.jsx";
import Page405 from "views/pagesNoLayout/Page405.jsx";
import Page406 from "views/pagesNoLayout/Page406.jsx";
import WPage from "views/pagesNoLayout/PageWoot.jsx";
import Chat from "views/pagesNoLayout/Chat/Chat";
import ChatRoom from "views/pagesNoLayout/Chat/ChatRoom";
import SetAmountTarget from "views/pagesNoLayout/settingDashboard/setAmountTarget";
import SetConfigDashboard from "views/pagesNoLayout/settingDashboard/setConfigDashboard";
import ForTestAPI from "views/pagesNoLayout/settingDashboard/forTestAPI";
import ForTestAni from "views/pagesNoLayout/settingDashboard/forTestAni";

import PageTestPage from "views/pagesNoLayout/PageTest";
import SurveyPage from "views/pagesNoLayout/Survey";

import PageRedirectRoute from "views/pagesNoLayout/PageRedirectRoute.jsx";

//forLogin:true จำเป็นต้องล็อกอินแล้ว , forGuest:true ต้องไม่ล็อกอินอยู่, ถ้าไม่ใส่สองตัวนี้คือเข้าได้หมด
const rootPath = ""
const pagesNoLayout = [
    {
        path: rootPath + '/pr/:code',
        component: PageRedirectRoute
    },
    {
        path: rootPath + '/survey/pr/:cus/:lng',
        component: SurveyPage
    },
    {
        path: rootPath + '/ChatRoom',
        component: ChatRoom
    },
    {
        path: rootPath + '/target',
        component: SetAmountTarget
    },
    {
        path: rootPath + '/configs',
        component: SetConfigDashboard
    },
    {
        path: rootPath + '/fortestapi',
        component: ForTestAPI
    },
    {
        path: rootPath + '/fortestani',
        component: ForTestAni
    },
    {
        path: rootPath + '/testcalling',
        component: PageTestPage
    },
    {
        path: rootPath + '/w',
        component: WPage
    },
    // {
    //     path: rootPath + '/charts'+
    //     '/:headerTotalScorePeriodInTime'+
    //     '/:topScoreLimit/:topScoreDuration'+
    //     '/:leadScorePeriodInTime/:leadScoreDuration'+
    //     '/:allScorePeriodInTime/:allScoreDuration',
    //     component: charts
    // },
    {
        forLogin: true,
        path: rootPath + "/page405",
        component: Page405
    },
    {
        forGuest: true,
        path: rootPath + "/page406",
        component: Page406
    },
    {
        //หน้าที่ไม่ตรงกับ Path ทั้งหมด
        path: rootPath + "/page404",
        component: Page404
    },
    // {
    //     redirect: true,
    //     path: rootPath + "/",
    //     pathTo: "/charts/dpt",
    //     // pathTo: "pages/login",

    //     // pathTo: 'charts'+
    //     // '/0'+
    //     // '/20/20'+
    //     // '/0/20'+
    //     // '/0/10',
    // },
    {
        //สำหรับ path ไม่ตรงเลยให้ย้ายไปหน้า page404
        redirect: true,
        path: rootPath,
        pathTo: "/pages/login"
        // pathTo: rootPath + "/page404"
    }
];

export default pagesNoLayout;
